import { Component, forwardRef, input, Resource, TemplateRef, viewChild, ChangeDetectionStrategy } from '@angular/core';

import { RemoteDataPanelViewBase } from '../remote-data-panel-view.base';
import { PanelViewBase } from '@softline/ui-core';
import { ResourceContainerComponent } from '@softapps/core';

@Component({
    selector: 'soft-grid-panel-view',
  imports: [ResourceContainerComponent],
    templateUrl: './grid.panel-view.html',
    styleUrl: './grid.panel-view.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: PanelViewBase, useExisting: forwardRef(() => GridPanelView) },
        { provide: RemoteDataPanelViewBase, useExisting: forwardRef(() => GridPanelView) }
    ]
})
export class GridPanelView<T> extends RemoteDataPanelViewBase<T[]> {
  override name = input.required<string>();
  override label = input<string>('Grid');
  override icon = input<string>('fa-regular fa-grid-2');
  override template = viewChild<TemplateRef<any>>('template');
  override resource = input.required<Resource<T[]>>();
}
